export default () => {
    return {
        animating: false,

        init() {
            TweenMax.set(this.$refs.arrow, { yPercent: 101 })
        },

        hover() {
            if (!this.animating) {
                this.animating = true

                const tl = new TimelineMax({
                    onComplete: () => {
                        this.animating = false
                    },
                })

                tl.fromTo(this.$refs.arrow, 0.5, { yPercent: 101 }, { yPercent: 0, ease: Circ.easeInOut })
            }
        },

        leave() {
            this.animating = true

            const tl = new TimelineMax({
                onComplete: () => {
                    this.animating = false
                },
            })

            tl.to(this.$refs.arrow, 0.3, { yPercent: -101, ease: Circ.easeInOut })
        },
    }
}
